import React, { useCallback } from 'react';
import { IDevice } from 'lavva.exalushome/build/js/Services/Devices/IDevice';
import { IDeviceChannel } from 'lavva.exalushome/build/js/Services/Devices/IDeviceChannel';
import { useConfigurationService } from '../../../device-details/hooks/use-configuration-service';

type DefaultConfigFormProps = {
  device: IDevice;
};

const DefaultConfigForm: React.FC<DefaultConfigFormProps> = ({ device }) => {
  const { UserManualButton } = useConfigurationService(device);

  return <>{UserManualButton}</>;
};

export default DefaultConfigForm;
